<template>
  <div class="flex">
    <div style="text-align: right; margin-bottom: 20px;">
      <crm-button
        v-if="auth.govProjectAdd && auth.govProjectAdd.toggleStatus"
        :size="'mini'"
        :text="'新增'"
        @click="toAdd()">
      </crm-button>
    </div>
    <el-table
      :data="projectData"
      v-loading="loading"
      style="width: 100%">
      <el-table-column
        show-overflow-tooltip
        prop="name"
        align="center"
        label="项目名称">
      </el-table-column>
      <el-table-column
        prop="projectTypeName"
        align="center"
        label="项目阶段">
      </el-table-column>
      <el-table-column
        prop="contact"
        align="center"
        width="88"
        label="对接人员">
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="contactDuty"
        align="center"
        width="120"
        label="对接人职务">
      </el-table-column>
      <el-table-column
        prop="contactTel"
        align="center"
        width="120"
        label="对接人联系方式">
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="landingDepartment"
        align="center"
        width="150"
        label="微医后续落地部门">
      </el-table-column>
      <el-table-column
        prop="landingDocker"
        width="120"
        align="center"
        label="落地部门负责人">
      </el-table-column>
      <el-table-column
        fixed="right"
        width="180"
        align="center"
        label="操作">
        <template slot-scope="{row}">
          <el-button
            v-if="auth.govProjectRecord && auth.govProjectRecord.toggleStatus"
            @click="toFollow(row)"
            type="text"
            size="small">
            跟进记录
          </el-button>
          <el-button
            v-if="auth.govProjectUpdate && auth.govProjectUpdate.toggleStatus"
            @click="toEdit(row)"
            type="text"
            size="small">
            编辑
          </el-button>
          <el-button
            v-if="auth.govProjectDelete && auth.govProjectDelete.toggleStatus"
            @click="delProject(row)"
            type="text"
            size="small">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <add
      :visible="addVisible"
      :id="id"
      @close="addVisible = false"
      @success="handleGetData">
    </add>
    <edit
      :visible="editVisible"
      :id="id"
      :detail="rowDetail"
      @close="editVisible = false"
      @success="handleGetData">
    </edit>
    <follow-record :visible="followVisible" :id="rowId" @close="followVisible = false"></follow-record>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CrmButton from '@/components/base/crmButton';
import Add from './project-add.vue';
import Edit from './project-edit.vue';
import FollowRecord from './project-follow.vue';

export default {
  components: {
    CrmButton,
    Add,
    Edit,
    FollowRecord,
  },
  props: {
    isCurrentTab: Boolean,
    id: String,
  },
  data() {
    return {
      loading: false,
      addVisible: false,
      editVisible: false,
      rowDetail: {},
      followVisible: false,
      rowId: null,
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      projectData: 'customer/projectData',
    }),
  },
  watch: {
    isCurrentTab(val) {
      if (val) this.handleGetData();
    },
  },
  methods: {
    ...mapActions({
      getProjectData: 'customer/getProjectData',
      deleteProject: 'customer/deleteProject',
    }),
    handleGetData() {
      this.loading = true;
      this.getProjectData({ inspectId: this.id }).finally(() => {
        this.loading = false;
      });
    },
    toAdd() {
      this.addVisible = true;
    },
    toEdit(row) {
      this.rowDetail = row;
      this.editVisible = true;
    },
    toFollow(row) {
      this.followVisible = true;
      this.rowId = row.id;
    },
    delProject(row) {
      this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.deleteProject({ id: row.id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.handleGetData();
          this.$emit('close');
        }).catch(() => {});
      }).catch(() => {});
    },
  },
};
</script>

<style>

</style>
